import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';

import { Button } from 'views/components/Button/Button';
import { Icon } from 'views/components/Icon/Icon';

interface Props {
  features: string[];
  showFeaturesLabel: string;
  hideFeaturesLabel: string;
  isDisabled?: boolean;
}

export const FeatureList = ({
  features, showFeaturesLabel, hideFeaturesLabel, isDisabled,
}: Props) => {
  const bodyRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const targetElement = bodyRef.current;
    if (targetElement) {
      targetElement.style.setProperty('--max-height', `${targetElement.scrollHeight}px`);
    }
  }, [setIsOpen]);

  return (
    <div className="FeatureList">
      {/* Features list and hide features list button */}
      <div className={classNames('FeatureList-body', { isOpen })} ref={bodyRef}>
        <ul className="FeatureList-list">
          {features.map((feature) => (
            <li className="FeatureList-item" key={feature}>
              <Icon name={isDisabled ? 'ic-tick-grey' : 'ic-tick-blue'} />
              <div className="">
                <p>{feature}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <Button
        className="Button FeatureList-button"
        label={isOpen ? hideFeaturesLabel : showFeaturesLabel}
        onClick={(e) => {
          if (e) {
            // Prevent radio button being selected when show/hide features button is pressed
            e.preventDefault();
            e.stopPropagation();
          }

          setIsOpen(!isOpen);
        }}
      />

    </div>
  );
};
